<template>
  <div v-show="canShow" class="ZIndex">
      <!-- 充值成功弹窗 -->
      <div class="ailogoRechargeSuccessful" v-if="ailogoRechargeSuccessful">
          <div class="ailogoRechargeSuccessful_bg">
              <div class="ailogoRechargeSuccessful_content">
              <div class="ailogoRechargeSuccessful_close" ><i class="el-icon-close" @click="closeWindow"></i></div>
              <div class="ailogoRechargeSuccessful_content_icon"><i class="el-icon-check"></i></div>
              <div class="ailogoRechargeSuccessful_content_title">恭喜您！充值成功</div>
              </div>
          </div>
      </div>

      <!-- 充值弹窗 -->
      <div class="ailogorechargepoints" v-show="!ailogoRechargeSuccessful">
          <div class="ailogorechargepoints_bg">
              <div class="ailogorechargepoints_content">
              <div class="ailogorechargepoints_content_bg"><img src="@a/img/bg28.jpg"/></div>
              <div class="ailogorechargepoints_content_left">
                  <div class="content_left_title">AI创作平台</div>
                  <div class="content_left_txt">
                  <div class="left_txt_list">
                      <div class="txt_list_dd">优质内容</div>
                      <div class="txt_list_dt">
                      <div class="list_dt_li"><i class="el-icon-check"></i>基于AI神经网络原创LOGO</div>
                      <div class="list_dt_li"><i class="el-icon-check"></i>最多可一键生成60张LOGO</div>
                      <div class="list_dt_li"><i class="el-icon-check"></i>可在线免费编辑二次创作</div>
                      <div class="list_dt_li"><i class="el-icon-check"></i>保证每次的创作都是源自AI</div>
                      <div class="list_dt_li"><i class="el-icon-check"></i>绝非传统LOGO库随机套用</div>
                      </div>
                  </div>
                  </div>
              </div>
              <div class="ailogorechargepoints_content_right">
                  <div class="content_right_top">
                  <div class="right_top_left">
                      <div class="top_left_img"><img :src="this.baseURL + this.$store.getters.memberInfo['avatar']"/></div>
                      <div class="top_left_right">
                      <div class="left_right_dd">{{ $store.getters.memberInfo['name'] }}</div>
                      <div class="left_right_dt">剩余创作次数：<span>{{ $store.getters.memberInfo.logo_num }}</span> 次</div>
                      </div>
                  </div>
                  <div class="right_top_close" @click="closeWindow"><img src="@a/img/close.svg"/></div>
                  </div>
                  <div class="content_right_bottom">
                  <div class="right_bottom_txt">
                      <div class="bottom_txt_recharge">
                        <MySwiper @child-click="handleChildClick" :list="rechargeList" :default_index="default_index"  v-if="can_swiper"></MySwiper>
                      </div>
                      <div class="bottom_txt_integral">
                        <div class="txt_integral_left">{{ remark }}</div>
                      </div>
                      <div class="bottom_txt_Benefit">
                      <div class="txt_Benefit_title">您将享受的权益</div>
                      <div class="txt_Benefit_con">
                          <div class="Benefit_con_list"><span><img src="@a/img/sv17.svg"/></span>最多20套方案选择</div>
                          <div class="Benefit_con_list"><span><img src="@a/img/sv18.svg"/></span>线上线下可商用</div>
                          <div class="Benefit_con_list"><span><img src="@a/img/sv19.svg"/></span>高清图免费下载</div>
                          <div class="Benefit_con_list"><span><img src="@a/img/sv20.svg"/></span>生成配套VI资产</div>
                          <div class="Benefit_con_list"><span><img src="@a/img/sv21.svg"/></span>永久放心使用</div>
                          <div class="Benefit_con_list"><span><img src="@a/img/sv22.svg"/></span>出图速度快质量高</div>

                      </div>
                      </div>
                  </div>
                  <div class="right_bottom_money">
                      <div class="bottom_money_title">
                      <div class="money_title_dd">￥{{ amoney }}</div>
                      <div class="money_title_dt">{{ describe }}</div>
                      </div>
                      <div class="bottom_money_img">
                      <span class="money_img_icon1"></span>
                      <span class="money_img_icon2"></span>
                      <span class="money_img_icon3"></span>
                      <span class="money_img_icon4"></span>
                      <img :src="images"/>
                      </div>
                      <div class="bottom_money_pay">
                      <span><img src="@a/img/sv23.svg"/></span>
                      <span><img src="@a/img/sv24.svg"/></span>
                      请用支付宝/微信扫码支付
                      </div>
                      <div class="bottom_money_protocol">
                      <div class="money_protocol_btn" @click="openProtocol">《会员服务协议》</div>
                      </div>
                  </div>
                  </div>
              </div>
              </div>
          </div>
      </div>



  </div>
</template>

<script>
  import MySwiper from "@c/common/ailogoSwiper/ailogoSwiper";
  import { Loading } from 'element-ui';

  export default {
      name: "logoRechargeWindow",
      data() {
          return {
            canShow: false,
            amoney: '',
            aintegral: '',
            describe: '',
            remark: '',
            images:'',
            ailogoRechargeSuccessful: false,
            interval: null,
            rechargeList: [],
            default_index: 0,
            can_swiper: false,
            reward_points: 0,
            loadingInstance: null,

          };
      },
      components: {
          MySwiper
      },
      methods: {
        openProtocol() {
          window.open('https://www.ai-dog.net/serviceAgreement.html', '_blank');
        },
        handleChildClick(money, integral, images, reward_points, describe, remark) {
          this.amoney = money
          this.aintegral = integral
          this.images = images
          this.reward_points = reward_points
          this.describe = describe
          this.remark = remark
        },
        closeWindow(){
          let that = this;

          clearInterval(that.interval)
          that.$emit('close')
        },
        getProductList(){
          let that = this;
          that.axios.post('/api/products/getLogoList').then(
              res => {
                if(res.code === 1){
                  that.rechargeList = res.result;
                  that.rechargeList.forEach( (item,index) => {
                    if(item.is_recommend){
                      that.default_index = index
                    }
                  })
                  let this_item = that.rechargeList[that.default_index]
                  that.handleChildClick(this_item.money, this_item.integral, this_item.images, this_item.reward_points, this_item.describe, this_item.remark)
                  that.can_swiper = true
                  that.canShow = true

                  that.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                    that.loadingInstance.close();
                  });

                  that.interval = setInterval(function(){
                    that.axios.post('/api/pointOrder/hasNewOrder').then(res=>{
                      if(res.code === 1) {
                        if(res.result){
                          // that.$message.success('支付成功')

                          that.ailogoRechargeSuccessful = true;

                          that.$emit('rechargePaySuccess'); // 通知父组件

                          // that.closeWindow()
                          clearInterval(that.interval)
                          that.axios.get('/api/member/getInfo').then(res => {
                            localStorage.setItem('memberInfo', JSON.stringify(res.result) )
                            that.$store.commit('setMemberInfo', res.result)
                          })
                        }
                      }
                    })
                  }, 1000)
                }
              }
          )
        }
      },
      created() {
        this.loadingInstance = Loading.service({});
        this.getProductList()


      }
  }
</script>

<style scoped>
  @import "logoRechargeWindow.css";
  .ZIndex{ position: relative; z-index: 50;}
</style>
